// Dark theme configuration
import { ThemeConfig, theme } from "antd";

export const darkTheme: ThemeConfig = {
  algorithm: theme.darkAlgorithm,
  token: {
    colorBgContainer: "#1c1c1c",
    colorText: "#ffffff",
    colorBorder: "#555",
    borderRadius: 6,
    controlHeight: 32,
    colorTextPlaceholder: "#9ca3af",
    colorPrimaryHover: "#1e1f4b",
    colorPrimaryActive: "#191a3d",
    colorError: "#ff4d4f",
    colorWarning: "#faad14",
    colorSuccess: "#52c41a",
    colorInfo: "#1890ff",
  },
  components: {
    Input: {
      colorBgContainer: "#333",
      colorText: "#ffffff",
      colorTextPlaceholder: "#9ca3af",
      colorBorder: "#555",
      borderRadius: 6,
      controlHeight: 32,
      paddingInline: 11,
      paddingBlock: 4,
      hoverBorderColor: "#40a9ff",
      activeShadow: "0 0 0 2px rgba(35, 36, 91, 0.2)",
    },
    InputNumber: {
      colorBgContainer: "#333",
      colorText: "#ffffff",
      colorTextPlaceholder: "#9ca3af",
      colorBorder: "#555",
      borderRadius: 6,
      controlHeight: 32,
      hoverBorderColor: "#40a9ff",
    },
    Button: {
      colorPrimaryHover: "#145fa8",
      colorPrimaryActive: "#191a3d",
      borderRadius: 6,
      controlHeight: 32,
      paddingInline: 15,
      paddingBlock: 4,
      fontWeight: 500,
      colorText: "#ffffff",
      colorBgContainer: "#333",
      colorBorder: "#555",
      colorTextDisabled: "#9ca3af",
      colorBgContainerDisabled: "#444",
      defaultHoverBorderColor: "#40a9ff",
      defaultHoverColor: "#23245b",
      defaultActiveBorderColor: "#23245b",
      defaultActiveColor: "#191a3d",
    },
    Form: {
      labelColor: "#ffffff",
      labelFontSize: 14,
      labelHeight: 32,
      labelRequiredMarkColor: "#ff4d4f",
      itemMarginBottom: 24,
      verticalLabelPadding: "0 0 8px",
    },
  },
};

export const darkThemeTokens = {
  sider: {
    colorBgMenuItemSelected: "#2f2f2f",
    textFontWeight: 500,
    textFontSize: 16,
    menuHeight: 40,
    colorTextMenu: "#ffffff",
    colorTextMenuSelected: "#4A6EEC",
    colorBgSider: "#000000", // Sidebar background color for dark theme
  },
  header: {
    colorBgHeader: "#333",
  },
};
